import axios from "axios";
import { getToken } from "@/utils/auth";
import store from "@/store";
import { Message } from "element-ui";
import router from "@/router.js";
import qs from "qs";
import Vue from "vue";
import { showLoading, hideLoading } from "./loading";

// let baseURL = `http://${process.env.VUE_APP_BASE_API}` ;


let baseURL = `http://${process.env.VUE_APP_BASE_API}`;

// 192.168.1.9:8090   60.205.232.26:8090
let axiosService = axios.create({
    baseURL,
    timeout: 180000,
});

axiosService.interceptors.response.use(
    (response) => {
        Vue.nextTick(() => {
            hideLoading();
        });

        // if (response.data.code !== 200) {
        //     Message.closeAll();
		// 	Message({
		// 	    message: response.data.msg  ||  "系统出现问题，请稍后重试！",
		// 	    type: "error",
		// 	    duration: 3 * 1000,
		// 	});
        // }
        return response.data;
    },
    (error) => {
        Vue.nextTick(() => {
            hideLoading();
        });
        Message.closeAll();

        if (error.response && error.response.status === 401) {
            Message({
                message: "您的用户身份已过期，请重新登录",
                type: "error",
                duration: 3 * 1000,
            });
            sessionStorage.clear();
            if (
                window.location.pathname != "/" &&
                window.location.pathname != "/login"
            ) {
                router.push({
                    name: "login",
                });
            }
        }else{
            Message({
                message: "网络错误！",
                type: "error",
                duration: 3 * 1000,
            });
        }

        return error;
    }
);

axiosService.interceptors.request.use((config) => {
    console.log('request',config,config.url)
    let configUrl = config.url;
    let needToken=true
    if (config.url=="/captchaImage" || config.url=="/register" || config.url=="/login" || config.url=="/oa/posts/list" || config.url=="/oa/comment/list"
         || config.url=="/oa/type/head/list" || config.headers.noProcess
     ) {
        needToken=false
    }

    if (store.state.login.token && needToken) {
        config.headers["authorization"] = getToken();
    }
    config.headers["Cache-Control"] = "no-cache";
    config.headers["Pragma"] = "no-cache";
    config.headers["r"] = new Date().getTime() + "" + Math.random();

    if (config.method === "get") {
        config.paramsSerializer = function (params) {
            return qs.stringify(params, {arrayFormat: "repeat"});
        };
    }
    return config;
});

export default axiosService;